import { Box, CircularProgress } from '@ori-ui/mui';
import { jsx as _jsx } from "react/jsx-runtime";
export var Loading = function Loading() {
  return /*#__PURE__*/_jsx(Box, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    height: "100%",
    justifyContent: "center",
    textAlign: "center",
    width: "100%",
    children: /*#__PURE__*/_jsx(CircularProgress, {
      color: "primary"
    })
  });
};